<template>
  <div class="feedback-retention" :class="{ 'feedback-retention-mobile': isMobile }">
    <el-dialog
      v-if="!isMobile"
      :visible.sync="dialogVisible"
      :show-close="tag ? false : true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @close="() => (res = 1)"
    >
      <p v-if="tag" soft="title" class="title">
        <span class="el-icon-success"></span>隐私问题反馈提交成功
      </p>
      <p v-else soft="title" class="title">
        <span class="el-icon-error"></span>隐私问题反馈提交失败
      </p>
      <div v-if="tag" class="content">
        您所反馈的隐私问题已提交成功，我们将尽快审核所涉问题，并在15个工作日或法律规定的期限内给予反馈。
      </div>
      <div v-else class="content">糟糕，您所反馈的隐私问题提交失败，请您稍后再试～</div>
      <div slot="footer" class="dialog-footer">
        <el-button v-if="tag" type="primary" @click="confirm">我知道了</el-button>
        <el-button v-else type="primary" @click="repeat">再试一次</el-button>
      </div>
    </el-dialog>
    <div v-if="!sign">
      <div class="feedback-retention-title">
        <span class="icon">*</span>请输入用以接收反馈的邮件地址
      </div>
      <div class="feedback-retention-content">
        <el-input
          v-model="email"
          placeholder="请输入您的邮箱地址"
          @change="emailChange"
          @blur="emailBlur"
          @focus="emailFocus"
          :style="{ borderColor: status ? 'red' : '' }"
        ></el-input>
        <p class="tips">我们将通过此邮箱与你联系，请务必提供正确有效的邮箱地址</p>
      </div>
      <el-button type="primary" @click.native="submit">提交</el-button>
    </div>
    <div class="result" v-else>
      <div class="result-icon">
        <div v-if="tag" class="el-icon-success icon"></div>
        <div v-else class="el-icon-error icon"></div>
      </div>

      <div class="tips">隐私问题反馈提交{{ tag ? "成功" : "失败" }}</div>
      <div class="content">
        <div v-if="tag">
          您所反馈的隐私问题已提交成功，我们将尽快审核所涉问题，并在15个工作日或法律规定的期限内给予反馈。
        </div>
        <div v-else>糟糕，您所反馈的隐私问题提交失败，请您稍后再试～</div>
      </div>
      <div class="submit-btn">
        <el-button v-if="tag" @click="confirm">我知道了</el-button>
        <el-button v-else @click="repeat">再试一次</el-button>
        <el-button class="return" v-if="!tag" @click="goBack">关闭</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import api from "@/api/index";
export default {
  name: "FeedbackRetention",
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      email: "",
      dialogVisible: false,
      status: false,
      tag: false,
      sign: false,
      res: 1,
    };
  },
  methods: {
    submit() {
      if (
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
          this.email
        )
      ) {
        if (this.res === 1) {
          this.form();
          this.$store.commit("app/CHANGE_STEP", 4);
        }
      } else {
        this.$message({
          type: "warning",
          message: "请填写格式正确的邮箱",
        });
      }
    },
    repeat() {
      this.form();
    },
    form() {
      // this.res = 2
      api
        .insertQuestion({
          email: this.email,
          phone: localStorage.getItem("phone"),
          productType: this.productType,
          questionDesc: this.desc,
          questionImgUrlList: this.url.split("@").slice(1),
          productName: this.productName,
          questionType: this.questionType,
          questionName: this.questionName,
          verifyCode: localStorage.getItem("code"),
          cityCode: this.cityCode,
          cityName: this.cityName,
        })
        .then((res) => {
          if (res.code === 0) {
            this.dialogVisible = true;
            this.res = 1;
            this.tag = true;
            if (isMobile) {
              this.$store.commit("app/CHANGE_SIGN", true);
              this.sign = true;
            }
          } else {
            this.dialogVisible = true;
            this.tag = false;
            if (isMobile) {
              this.$store.commit("app/CHANGE_SIGN", true);
              this.sign = true;
            }
          }
        });
    },
    goBack() {
      this.sign = false;
      this.res = 1;
      this.$store.commit("app/CHANGE_SIGN", false);
    },
    confirm() {
      this.dialogVisible = false;
      this.$router.push("/privacy-attestation");
    },
    emailChange(value) {
      this.email = value;
    },
    emailBlur() {
      if (
        !/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
          this.email
        )
      ) {
        this.status = true;
      } else {
        this.status = false;
        this.$store.commit("app/CHANGE_EMAIL", this.email);
        this.$store.commit("app/CHANGE_STEP", 4);
      }
    },
    emailFocus() {
      if (
        !this.email ||
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
          this.email
        )
      ) {
        this.status = false;
      } else {
        this.status = true;
      }
    },
  },
  computed: {
    step() {
      return this.$store.state.app.step;
    },
    productType() {
      return this.$store.state.app.productType;
    },
    desc() {
      return this.$store.state.app.desc;
    },
    url() {
      return this.$store.state.app.questionImgUrl;
    },
    questionType() {
      return this.$store.state.app.questionType;
    },
    productName() {
      return this.$store.state.app.productName;
    },
    questionName() {
      return this.$store.state.app.questionName;
    },
    cityCode() {
      return this.$store.state.app.cityCode;
    },
    cityName() {
      return this.$store.state.app.cityName;
    }
  },
  mounted() {
    if (this.step === 1) {
      this.$router.push("/dsr/product");
    }
    this.email = this.$store.state.app.email;
  },
};
</script>
<style lang="scss">
.feedback-retention {
  font-size: calc($multiple * 0.215px * 80);
  .icon {
    color: red;
    margin-right: calc(0.1px * 80 * $multiple);
  }
  .feedback-retention-content {
    margin-top: calc($multiple * 0.13px * 80);
    .tips {
      margin-top: calc($multiple * 0.2px * 80);
      color: rgba(0, 0, 0, 0.76);
      font-size: calc($multiple * 0.215px * 80);
    }
    .el-input {
      height: calc($multiple * 0.68px * 80);
      width: calc($multiple * 5.9px * 80);
      border-radius: 3px;
      border: 1px solid rgba(0, 0, 0, 0.15);
      input {
        height: calc($multiple * 0.33px * 80);
      }
      .el-input__inner {
        /* margin-top: calc($multiple * 0.1px * 80); */
        border: 0 !important;
        height: 100% !important;
        border-radius: 3px;
        /* height: calc($multiple * 0.45px * 80) !important; */
        font-size: calc($multiple * 0.215px * 80);
      }
    }
  }
  .el-button {
    width: calc($multiple * 1.96px * 80);
    height: calc($multiple * 0.67px * 80);
    border-radius: calc($multiple * 0.1px * 80) !important;
    margin-top: calc($multiple * 3.3px * 80);
    margin-left: calc($multiple * 2.5px * 80);
    text-align: center;
    padding: 0 !important;
    span {
      font-size: calc($multiple * 0.215px * 80);
    }
  }
  .el-dialog {
    width: calc($multiple * 7.38px * 80);
    height: calc($multiple * 4px * 80);
    box-shadow: 0px 12px 48px 16px rgba(0, 0, 0, 0.03),
      0px 9px 28px 0px rgba(0, 0, 0, 0.05), 0px 6px 16px -8px rgba(0, 0, 0, 0.08);
    border-radius: 5px;
    .el-dialog__header {
      padding: 0;
      height: calc($multiple * 0.56px * 80);
    }
    .el-dialog__footer {
      position: relative;
      .el-button.el-button--primary {
        position: absolute;
        left: calc($multiple * 2.7px * 80);
        width: calc($multiple * 1.96px * 80);
        height: calc($multiple * 0.67px * 80);
        top: calc($multiple * 0.5px * 80);
        text-align: center;
        background: #0072f5;
        border-radius: 5px;
        margin: 0;
        span {
          font-size: calc($multiple * 0.215px * 80);
        }
      }
    }
  }
  .el-dialog__body {
    padding: 0 calc($multiple * 1.15px * 80);
    font-size: calc($multiple * 0.25px * 80);
    .content {
      margin-top: calc($multiple * 0.276px * 80);
      font-size: calc($multiple * 0.215px * 80);
      height: calc($multiple * 72px);
    }
  }
  .title {
    text-align: center;
    font-size: calc($multiple * 0.25px * 80);
    color: rgba(0, 0, 0, 0.85);
  }
  .el-icon-success,
  .el-icon-error {
    color: #52c41a;
    margin-right: calc($multiple * 10px);
    font-size: calc($multiple * 22px);
  }
  .el-icon-error {
    color: red;
  }
  .el-dialog__close {
    font-size: 20px;
  }
}

.feedback-retention-mobile {
  font-size: 0.72rem;
  .icon {
    margin-right: 0.2rem;
  }
  .feedback-retention-title {
    padding: 0.72rem 0;
  }
  .feedback-retention-content {
    margin-top: 0.08rem;
    .tips {
      margin-top: 0.36rem;
      font-size: 0.613rem;
    }
    .el-input {
      height: 2.25rem;
      width: 100%;
      border-radius: 0.16rem;
      border: 1px solid rgba(0, 0, 0, 0.15);
      .el-input__inner {
        margin-top: 0;
        height: 100%;
        border-radius: 0.45rem;
        /* height: 1.5rem !important; */
        /* padding: 0.6rem 0 0 0.61rem; */
        font-size: 0.72rem;
      }
    }
  }
  .el-button {
    margin-top: 1.84rem;
    margin-bottom: 1.12rem;
    width: 6.56rem;
    height: 2.25rem;
    border-radius: 0.16rem !important;
    margin-left: 5.5rem;
    span {
      font-size: 0.72rem;
    }
  }
}
.result {
  .result-icon {
    height: 3.06rem;
    width: 100%;
    text-align: center;
    margin-top: 2.2rem;
    div {
      margin: auto;
      font-size: 3rem;
    }
  }
  .tips {
    margin-top: 0.92rem;
    text-align: center;
  }
  .content {
    margin-top: 0.92rem;
    div {
      width: 13rem;
      margin: auto;
      font-size: 0.72rem;
      font-family: PingFangSC-Regular, PingFang SC;
      color: rgba(0, 0, 0, 0.64);
    }
  }
  .return {
    margin-top: 0;
    background-color: #ccc !important;
    border: 0 !important;
  }
}
</style>
